import { bootstrap } from "./bootstrap";

bootstrap().catch((error) => {
  console.error("Failed to bootstrap app", error);
});
